import _ from 'underscore'
import React, { useCallback } from 'react'

import Checkbox from 'components/Checkbox'

type Props = {
  items: Array<{id: number | string, label: string}>
  selectedIds: Array<number | string>
  onSelectedIdsChange: (ids) => void
}

const CheckboxList = ({ items, selectedIds, onSelectedIdsChange }: Props) => {
  const isItemSelected = useCallback((id) => _.includes(selectedIds, id), [selectedIds])

  const toggleItemInIdList = useCallback((id) => {
    if (isItemSelected(id)) {
      return _.without(selectedIds, id)
    } else {
      return selectedIds.concat(id)
    }
  }, [isItemSelected, selectedIds])

  return (
    <>
      {_.map(items, ({ id, label }) => (
        <Checkbox
          key={id}
          listId={id + ''}
          checked={isItemSelected(id)}
          onChange={() => onSelectedIdsChange(toggleItemInIdList(id))}
          label={label}
        />
      ))}
    </>
  )
}

export default CheckboxList
